export function setAllStore(checked) {
    if(checked){
        localStorage.setItem("pagewiseallstorecheckbox",parseInt(process.env.REACT_APP_ALL_STORE));
    }
    else{
        localStorage.removeItem("pagewiseallstorecheckbox");
    }
}